export enum ListStyle {
  Concatenated,
  Bullet,
}
